/// <amd-module name="Wit/Settings/BoardsExternalIntegration/components/panels/enterprise/newConnection/EnterpriseNewConnectionPanel.Props" />
import { IDisableOAuthProps } from "Wit/Settings/BoardsExternalIntegration/components/panels/DisableOAuth.props";
import { IBasePanelContentProps } from "Wit/Settings/BoardsExternalIntegration/components/panels/BasePanelContent.Props";
import { IShowPanelProps } from "Wit/Settings/BoardsExternalIntegration/components/panels/ShowPanel.props";

export interface IEnterpriseNewConnectionPanelProps extends IBasePanelContentProps, IShowPanelProps, IDisableOAuthProps {}
